var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-container"},[_vm._t("header"),(_vm.isError)?_c('content-block',[_c('el-empty',{attrs:{"description":_vm.errorText}},[_vm._t("error")],2)],1):[_vm._t("default")]],2),(!_vm.isError)?_vm._t("footer"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }